import { render, staticRenderFns } from "./CDrawrMenu.vue?vue&type=template&id=ed5eb33a&"
import script from "./CDrawrMenu.vue?vue&type=script&lang=ts&"
export * from "./CDrawrMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports